import React, { useState, useEffect } from 'react';

const ScrollButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Styles for the button
  const buttonStyle = {
    position: 'fixed',
    bottom: '20px',  
    right: '20px',  
    backgroundColor: '#007bff', 
    color: 'white', 
    border: 'none',
    borderRadius: '5px',
    padding: '10px 15px',
    fontSize: '16px',
    cursor: 'pointer',
    opacity: isVisible ? 1 : 0, 
    transition: 'opacity 0.3s'  
  };

  // Styles for the hover effect
  const hoverStyle = {
    backgroundColor: '#0056b3' 
  };

  return (
    <button
      style={buttonStyle}
      onClick={scrollToTop}
      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor}
      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#007bff'}
    >
      &#9650;
    </button>
  );
};

export default ScrollButton;
